/**
 * Response-phrase list helpers for the partner-endpoint form (epic 084 D3).
 *
 * The endpoint form shows each `response_rules` list as one comma-separated
 * text field and saves it split on commas — the same semantics the campaign
 * form's Simple-URL phrase fields use (`campaign-form.tsx` `joinArr`, load,
 * and `parsePhrase`, save). Recorded residue (D3): a phrase cannot contain a
 * comma, and an explicit empty array is saved as an absent key.
 */

/**
 * Load half — mirrors the campaign form's `joinArr` (`campaign-form.tsx`
 * :978-992, epic 084 D3). An array → its string entries joined with `', '`;
 * anything else (absent, `null`, a non-array) → `''`.
 */
export function joinPhrases(value: unknown): string {
  if (!Array.isArray(value)) return '';
  return value.filter((entry): entry is string => typeof entry === 'string').join(', ');
}

/**
 * Save half — mirrors the campaign form's `parsePhrase` (`campaign-form.tsx`
 * :1133-1149, epic 084 D3). Split on `','`, trim each part, drop empty
 * parts; `''` and `' , ,'` → `[]`.
 */
export function splitPhrases(text: string): string[] {
  return text
    .split(',')
    .map((part) => part.trim())
    .filter((part) => part.length > 0);
}
